import { render, staticRenderFns } from "./SectionTwo.vue?vue&type=template&id=ea8b47d2&scoped=true&"
var script = {}
import style0 from "./SectionTwo.vue?vue&type=style&index=0&id=ea8b47d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea8b47d2",
  null
  
)

export default component.exports